<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>{{$t('faq.title')}}</h2>
        <div class="irinox-form" >
          <AlarmAccordion class="faq-accordion p-mt-5" :multiple="true">
              <AccordionTab v-for="item in faq" :key="item">
                  <template #header>
                      <span>{{item.q}}</span>
                  </template>
                  <span>{{item.a}}</span>
              </AccordionTab>
          </AlarmAccordion>
        </div>
		</div>
	</div>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('faq.error_dialog')"
    :life="5000" @update:visible="dialog.error = $event" />

</template>

<script>
import AccountService from '../../service/AccountService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
import AlarmAccordion from "../AlarmAccordion.vue";

export default {
    components: {
        IrinoxDialogDark,
        AlarmAccordion,
    },
    data() {
        return {
          faq: [],
          dialog: {
            error: false
          }
        };
    },
    computed: {
      ...mapGetters({
          role: 'userdata/role',
          personaltoken: 'userdata/personaltoken',
        }),
    },
    created() {
      this.accountService = new AccountService();
    },
    mounted() {
      this.load();
    },
    methods: {
      load() {
        this.faq = [];
        this.accountService.getFaq(this.$i18n.locale)
          .then(data => {
            if(this.role==='USER') {
              this.faq = this.faq.concat(data.user);
            } else if(this.role.includes('SERVICE')) {
              this.faq = this.faq.concat(data.service);
            }
            this.faq = this.faq.concat(data.common);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      }
    }
}
</script>

<style scoped>

</style>